<label [class.input-group]="hasIcon">
    {{label}}
    <span class="input-group-label" *ngIf="hasIcon"><ng-content select="[icon]"></ng-content></span>
    <div class="input">
        <input #input
               [required]="required"
               [disabled]="disabled"
               [class._delete]="delete"
               [class._search]="search"
               [class._disabled]="disabled"
               [placeholder]="placeholder"
               [type]="inputType" [ngModel]="data" (ngModelChange)="onChange($event)">
        <a *ngIf="delete" (click)="onDelete()" class="deleteIcon"><i class="fas fa-times-circle"></i></a>
    </div>
</label>
